<template>
    <div class="change-app-lang-component-container">
        <div class="component-wrapper">
            <div v-if="loadingPage" class="spinner-container">
                <div class="spinner">
                    <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                </div>
            </div>
            <div class="change-app-lang-content-container">
                <div class="langs-list-content-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            {{ $t('select_app_language') }}
                        </p>
                    </div>
                    <div class="langs-list-container">
                        <ul class="langs-list">
                        <li v-for="(langObj, index) in $store.appLangsArr" class="lang-container" :key="index" 
                            :class="$store.selectedAppLanguage == langObj.countryCode ? 'selected' : ''" @click="selectActiveLangHandle(langObj.countryCode)">
                            <div class="lang-text-container">
                                <p>{{ langObj.language }}</p>
                            </div>
                            <div class="selected-lang-img-container">
                                <img v-if="$store.selectedAppLanguage == langObj.countryCode" src="../../assets/icons/check.png" alt="Select Icon">
                            </div>
                        </li>
                    </ul>
                    </div>
                </div>

                <div class="back-to-settings-btn-container">
                    <div class="back-to-settings-btn-wrapper" @click="closeChangeAppLanguagePageHandle">
                        <div class="back-arrow-img-container">
                            <img src="../../assets/icons/arrow_back.png" alt="Arrow Image">
                        </div>
                        <div class="text-container">
                            <p class="back-to-settings-btn">{{ $t('back_to_settings') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChangeAppLanguage',
    props: {
        closeChangeAppLanguagePageHandle: Function,
    },
    data() {
        return {
            loadingPage: false,
            // successLoadingPage: true,
            // failedLoadingPage: false,
        };
    },
    methods: {
        selectActiveLangHandle: async function (lang) {
            this.loadingPage = true;
            try {
                // Get user data from local storage.
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.loadingPage = false;
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    if (lang.toLowerCase() !== this.$store.selectedAppLanguage) {
                        // Try to update the user's app language in db.
                        const data = {
                            email: localStorageUser.email,
                            token: localStorageUser.token,
                            appLang: lang.toLowerCase(),
                        };

                        const updateAppLanguageResponse = await fetch("../../api/user/updateAppLanguage", {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=UTF-8',
                            },
                            body: JSON.stringify(data),
                        });

                        const updateAppLanguageResponseJson = await updateAppLanguageResponse.json();

                        if (!updateAppLanguageResponseJson.status) {
                            if (updateAppLanguageResponseJson.invalidToken) {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.loadingPage = false;
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'failed';
                                this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                            }
                        }
                        else {
                            this.$store.changeAppLanguage(lang);
                            // if (this.$store.requestSource.includes("webView")) {
                            //     await window.flutter_change_app_language.postMessage(JSON.stringify({appLang: lang}));
                            // }
                            this.loadingPage = false;
                        }
                    }
                }
            }
            catch(err) {
                console.log("Error changing app language...");
                console.log(err);
                this.loadingPage = false;
                this.$store.showErrorPopup = true;
                this.$store.errorPopupTitle = 'unfortunately';
                this.$store.errorPopupMsg = 'something_went_wrong_try_again';
            }
        }
    }
}
</script>

<style>
.change-app-lang-component-container {
    position: relative;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.change-app-lang-component-container .component-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.change-app-lang-component-container .spinner-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    z-index: 150;
}

.change-app-lang-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.change-app-lang-component-container .change-app-lang-content-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.change-app-lang-component-container .langs-list-content-container {
    flex: 1;
    width: 90%;
    max-width: 500px;
    padding: 30px 20px;
    /* border: 1px solid red; */
}

.change-app-lang-component-container .info-text-container {
    width: 100%;
    max-width: 475px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5% 0 25px;
}

.change-app-lang-component-container .info-text-container .info-text {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
    /* border: 1px solid red; */
}

.change-app-lang-component-container .langs-list-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    /* border: 1px solid red; */
}

.change-app-lang-component-container .langs-list {
    width: 100%;
}

.change-app-lang-component-container .lang-container {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px 15px;
    margin-bottom: 10px;
    border-radius: 30px;
    border: 1px solid #616365;
    cursor: pointer;
}

.change-app-lang-component-container .lang-text-container {
    flex: 1;
    /* border: 1px solid red; */
}

.change-app-lang-component-container .lang-text-container p {
    font-size: 22px;font-size: 20px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
}

.change-app-lang-component-container .selected-lang-img-container {
    width: 30px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.change-app-lang-component-container .selected-lang-img-container img {
    width: 100%;
}

.change-app-lang-component-container .selected {
    /* border: 1px solid #92d400; */
    background: #92d400;
    border: 1px solid #92d400;
}

.change-app-lang-component-container .selected p {
    color: #ffffff;
}

.change-app-lang-component-container .back-to-settings-btn-container {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px;
    /* border: 1px solid; */
}

[dir="rtl"] .change-app-lang-component-container .back-to-settings-btn-container {
    direction: ltr;
}

.change-app-lang-component-container .back-to-settings-btn-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.change-app-lang-component-container .back-arrow-img-container {
    width: 15px;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    margin-right: 5px;
    /* border: 1px solid; */
}

.change-app-lang-component-container .back-to-settings-btn-wrapper .text-container p {
    color: #009df4;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 18px;
}

.change-app-lang-component-container .back-arrow-img-container img {
    width: 100%;
}

@media (max-width: 425px) {
    .change-app-lang-component-container .info-text-container .info-text {
        font-size: calc(18px + 2vw);
    }

    .change-app-lang-component-container .lang-container {
        padding: 3px 15px;
    }

    .change-app-lang-component-container .lang-text-container p {
        font-size: calc(14px + 1vw);
    }

    .change-app-lang-component-container .back-arrow-img-container {
        width: 12px;
    }

    .change-app-lang-component-container .back-to-settings-btn-wrapper .text-container p {
        font-size: calc(12px + 1vw);
    }
}

</style>